export const onlyDigits = (val: string): number => Number(val.replace(/\D/g, ''))
